<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="top-level"
	[ngStyle]="{
		transform: 'scale(' + scalePercent / 100 + ')',
		'transform-origin': 'top left',
		width: '' + scalePercent + 'px',
		height: '' + scalePercent + 'px'
	}"
	[ngSwitch]="state"
>
	<div *ngSwitchCase="notStarted">
		<mat-icon class="icon"></mat-icon>
	</div>

	<div *ngSwitchCase="inProgress">
		<mat-progress-spinner
			class="report-progress"
			[diameter]="80"
			[strokeWidth]="10"
			[color]="spinnerThemePalette"
			[mode]="spinnerMode"
			[value]="spinnerValue"
		>
		</mat-progress-spinner>
	</div>

	<div *ngSwitchCase="success">
		<mat-icon class="success-icon">check_circle</mat-icon>
	</div>

	<div *ngSwitchCase="failure">
		<mat-icon class="failure-icon">error</mat-icon>
	</div>
</div>
